import { X } from 'lucide-react';

export function DocumentsDeleteModal({ document, onClose, onConfirm }) {
  if (!document) return null;

  return (
    <div data-testid="documents-delete-modal" className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
      <div className="w-full max-w-md space-y-4 rounded-md border border-border bg-card p-6">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-medium">Confirmer la suppression</h3>
          <button type="button" data-testid="documents-delete-close" onClick={onClose} className="rounded p-1 transition-colors hover:bg-zinc-800">
            <X className="h-5 w-5" />
          </button>
        </div>

        <p className="text-muted-foreground">
          Êtes-vous sûr de vouloir supprimer le document <strong className="text-white">“{document.title}”</strong> ?
        </p>
        <p className="text-xs text-red-400">Cette action est irréversible. Tous les chunks associés seront également supprimés.</p>

        <div className="flex gap-3 pt-2">
          <button type="button" onClick={onClose} className="h-10 flex-1 rounded-sm border border-zinc-800 bg-transparent text-white transition-colors hover:border-white">
            Annuler
          </button>
          <button type="button" data-testid="documents-delete-confirm" onClick={onConfirm} className="h-10 flex-1 rounded-sm bg-red-600 font-medium text-white transition-colors hover:bg-red-700">
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}
